
























import { Component, Prop, Vue } from "vue-property-decorator";
import { ITag } from "@/models/tag.entity";
import Tooltip from "../utility/tooltip.vue";

@Component({ components: { Tooltip } })
export default class TagChip extends Vue {
  @Prop({ required: true })
  value!: ITag;

  @Prop({ default: "medium" })
  size?: "x-small" | "small" | "medium" | "large" | "x-large";
}
